export default {
  allMusicTitle: '找到心仪的音乐',
  musicAccount: '{num}+音乐',

  cancelSuccessTip: '已取消',
  shareSuccessTip: '已复制该音乐链接至剪贴板，快去分享吧～',
  collectSuccessTip: '收藏成功，您可以在【个人中心-我的收藏】中查看该音乐～',
  downloadAudioTipTitle: '下载试听音频',
  downloadTryAudioTip: '您正在下载带水印低音质版本的音频，该版本音频仅用于试用，如需高品质版本，请先购买~',
}